/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
import pageContext from '@bingads-webui-static-legacy/page-context';
import config from '@bingads-webui-component-legacy/config/index';
import * as budgetRangeModule from '@bingads-webui-campaign-legacy/common-grid-config/budget/get-budget-range';
import decimalNumber from '@bingads-webui-component-legacy/humanize/decimal';
import humanizeNumber from '@bingads-webui-component-legacy/humanize/number';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
import * as _currenyFormatter from '@bingads-webui-campaign-legacy/budget/shared/currencyFormatter';
import '@bingads-webui-component-legacy/extension/underscore';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var s$Budget = window.globalLegacySchema.get('Budget');
var formatCost = _currenyFormatter.formatCost;
var BudgetTypes = {
  DailyStandard: 'DailyStandard',
  DailyAccelerated: 'DailyAccelerated',
  LifetimeBudgetStandard: 'LifetimeBudgetStandard'
};
var BudgetScopes = {
  Daily: 'Daily',
  Lifetime: 'Lifetime'
};
var BudgetTypesToBudgetScope = {
  [BudgetTypes.DailyStandard]: BudgetScopes.Daily,
  [BudgetTypes.DailyAccelerated]: BudgetScopes.Daily,
  [BudgetTypes.LifetimeBudgetStandard]: BudgetScopes.Lifetime
};
var BudgetTypeSectionOptions = [{
  value: BudgetTypes.DailyStandard,
  text: i18n.get('BudgetLimitType_Daily')
}, {
  value: BudgetTypes.LifetimeBudgetStandard,
  text: i18n.get('BudgetLimitType_Lifetime')
}];
var currencyCode = config.get('AccountCurrencyCode');
var isDeprecateAcceleratedBudgetEnabled = pageContext.Permissions.IsDeprecateAcceleratedBudgetEnabled;
var isDeprecateAcceleratedBudgetOptout = pageContext.Permissions.IsDeprecateAcceleratedBudgetOptoutEnabled;
var ViewModel = function (options) {
  var budgetRangeNew = budgetRangeModule.getBudgetRange(currencyCode);
  var budgetRange = budgetRangeModule.getBudgetRangeOld(currencyCode);
  if (options.validationDailyMinBudget && !_.isEmpty(budgetRange)) {
    budgetRange.DailyRange.FloorValue = options.validationDailyMinBudget;
  }
  var USDefaultBudget = pageContext.Permissions.IsDefaultBudgetExperimentationEnabled ? 25 : 20;
  var realDefaultBudget = budgetRangeNew.Daily.Default;
  var defaultBudget = pageContext.AccountCurrencyCode && pageContext.AccountCurrencyCode === 'USD' ? USDefaultBudget : realDefaultBudget;
  if (options.validationDailyMinBudget && defaultBudget < options.validationDailyMinBudget) {
    defaultBudget = options.validationDailyMinBudget;
  }
  var budget = _.defaults({}, options.budget, {
    Amount: defaultBudget,
    Type: BudgetTypes.DailyStandard
  });
  this.suggestedBudget = ko.observable(0);
  this.clicksIncrease = ko.observable(0);
  this.isDailyBudgetExpanded = ko.observable(false);
  this.showFACHint = ko.observable(false);
  this.featureAdoptionCouponValue = ko.observable(0);
  this.budgetTypeSelectionOptions = BudgetTypeSectionOptions;
  this.selectedBudgetType = ko.observable(BudgetTypes.DailyStandard);
  this.showBudgetTypeSelectionOptions = options.showBudgetTypeSelection;
  this.allowBudgetTypeSelection = options.allowBudgetTypeSelection;
  this.budgetAmountPlaceholder = i18n.get('CampaignSetting_Placeholder_Budget').replace('{0}', decimalNumber.fromLocalToString(defaultBudget));
  ko_schema.properties(this, s$Budget, ['Amount', 'Type'], budget);
  this.BudgetScope = ko.observable(BudgetTypesToBudgetScope[budget.Type]);
  this.isDailyStandard = ko.observable(budget.Type === BudgetTypes.DailyStandard);
  this.hideDailyBudgetOptions = options.hideDailyBudgetOptions;
  this.readOnly = options.readOnly;
  this.hideAcceleratedBudgetOption = ko.computed(function () {
    return isDeprecateAcceleratedBudgetEnabled && budget.Type === BudgetTypes.DailyStandard;
  });
  this.showSuggestedBudget = ko.computed(function () {
    return this.Amount() < this.suggestedBudget() && this.clicksIncrease() > 0;
  }, this);
  this.showBudgetMinRecommend = ko.computed(function () {
    const showBudgetMinRecommend = options.showBudgetMinRecommend && options.minimumBudget && options.minimumBudget >= 0.05 && this.Amount() && this.Amount() < options.minimumBudget;
    if (options.activityLogger && showBudgetMinRecommend) {
      options.activityLogger.trace('BCCForBudgetMinimumRecommendation: show');
    }
    return showBudgetMinRecommend;
  }, this);
  this.budgetSuggestion = ko.computed(function () {
    return i18n.get('Creation_Workflow_Budget_Suggestion_Per_Month', {
      increasedClicks: humanizeNumber.format(this.clicksIncrease()),
      budget: formatCost(this.suggestedBudget())
    });
  }, this);
  this.isDailyStandard.forEditing = ko.computed({
    read: function () {
      return this.isDailyStandard().toString();
    },
    write: function (newValue) {
      return this.isDailyStandard(newValue === 'true');
    }
  }, this);
  this.budgetLimit = ko.computed(function () {
    if (!_.isEmpty(budgetRange)) {
      var budgetScope = this.BudgetScope();
      return budgetScope === BudgetScopes.Daily ? budgetRange.DailyRange : budgetRange.LifetimeRange;
    }
  }, this);
  this.featureAdoptionCouponHint = ko.computed(function () {
    return i18n.get('Coupon_applied_10days', {
      value: this.featureAdoptionCouponValue()
    });
  }, this);
  ko.computed(function () {
    if (this.showBudgetTypeSelectionOptions && this.allowBudgetTypeSelection) {
      this.Type(this.selectedBudgetType());
      this.BudgetScope(BudgetTypesToBudgetScope[this.selectedBudgetType()]);
    }
  }, this);
  var amountTypeValidator = _.result(this.Amount.validators, 'type');
  if (amountTypeValidator) {
    amountTypeValidator.message = i18n.get('Campaigns_InlineValidBudgetInputMsg');
  }
  var amountSizeValidator = _.result(this.Amount.validators, 'decimalLength');
  if (amountSizeValidator) {
    amountSizeValidator.message = i18n.get('Campaigns_InlineValidBudgetInputMsg');
  }
  (this.computeBudgetError = function () {
    var budget = this.Amount(), minValue = this.budgetLimit().FloorValue, maxValue = this.budgetLimit().CeilingValue;
    if (_.isNil(budget)) {
      return i18n.get('CampaignBudget_Validation_RequiredField');
    }
    if (_.isEmpty(budgetRange)) {
      return '';
    }
    if (this.Amount.isValid() && (budget < minValue || budget > maxValue)) {
      return this.BudgetScope() === BudgetScopes.Daily ? i18n.get('Budget_InputValueError_Daily').replace('{0}', options.accountCurrencyCode).replace('{1}', decimalNumber.fromFloatToString(this.budgetLimit().FloorValue)) : i18n.get('Budget_InputValueError_Lifetime').replace('{0}', options.accountCurrencyCode).replace('{1}', decimalNumber.fromFloatToString(this.budgetLimit().FloorValue)).replace('{2}', options.accountCurrencyCode).replace('{3}', decimalNumber.fromFloatToString(this.budgetLimit().CeilingValue));
    }
    return '';
  }, this.useSuggestedBudget = function () {
    this.Amount(this.suggestedBudget());
  });
  this.applySuggestedBudget = function () {
    if (options.minimumBudget) {
      if (options.activityLogger) {
        options.activityLogger.trace('BCCForBudgetMinimumRecommendation: apply');
      }
      this.Amount(options.minimumBudget * 1);
    }
  };
  this.budgetError = ko.computed(this.computeBudgetError, this);
  this.Amount.subscribe(() => {
    this.Amount.validate();
  });
  this.budgetInvalid = ko.computed(function () {
    return !_.isEmpty(this.budgetError()) || !this.Amount.isValid();
  }, this);
  this.budget = ko.computed(function () {
    return this.Amount();
  }, this);
  this.budgetType = ko.computed(function () {
    return this.Type();
  }, this);
  this.budgetLabel = ko.computed(function () {
    return this.budgetInvalid() ? i18n.get('Label_Budget') : i18n.get('Campaign budget per day by {{unit}}').replace('{{unit}}', options.accountCurrencyCode);
  }, this);
  this.budgetTypeLabel = ko.computed(function () {
    return i18n.get('Label_BudgetType');
  }, this);
};
ViewModel.prototype.updateSuggestedBudget = function (suggestedBudget, clicksIncrease) {
  this.suggestedBudget(suggestedBudget ? suggestedBudget : 0);
  this.clicksIncrease(clicksIncrease ? clicksIncrease : 0);
};
ViewModel.prototype.update = function (model) {
  if (_.isObject(model)) {
    if (this.Amount() !== model.Amount) {
      this.Amount(model.Amount);
    }
    this.Type(model.Type);
    this.BudgetScope(BudgetTypesToBudgetScope[model.Type]);
    this.isDailyStandard(model.Type === BudgetTypes.DailyStandard);
    this.selectedBudgetType(model.Type);
  }
};
ViewModel.prototype.enough = function () {
  return this.Amount() >= this.suggestedBudget();
};
ViewModel.prototype.updateFeatureAdoptionCoupon = function ({showFACHint, couponValue}) {
  this.showFACHint(showFACHint);
  this.featureAdoptionCouponValue(couponValue);
};
export default ViewModel;
